import { render } from "./vselect.vue?vue&type=template&id=5e2619ef"
import script from "./vselect.vue?vue&type=script&lang=js"
export * from "./vselect.vue?vue&type=script&lang=js"

import "./vselect.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/var/www/apps/mydr/mydr-welcome/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__